import { IRewardClaimDetailMock } from "../mock";
import { RaffleStatusTypes } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { Masks } from "@hooks/functions/Masks/Masks";
import { getRaffleStatus } from "@hooks/functions/Raffle/status";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaCalendarDays, FaTicket } from "react-icons/fa6";
import { RewardThumb } from "../../components/RewardThumb";

const masks = new Masks();

interface IProps {
  detail: IRewardClaimDetailMock;
}

export function RewardDetailHeader({ detail }: IProps) {
  const status = getRaffleStatus(detail.raffle.status as RaffleStatusTypes);
  const campaignUrl = `/campaign/default?key=${detail.raffle.key}`;

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex flex-column flex-lg-row justify-content-between gap-3">
          <div className="d-flex align-items-start gap-3">
            <Link to={campaignUrl} title="Abrir campanha pela key.">
              <RewardThumb
                src={detail.raffle.thumb}
                alt={detail.raffle.name}
                size={76}
              />
            </Link>
            <div>
              <div className="d-flex flex-wrap gap-2 mb-2">
                <span
                  className={`badge bg-${status.color} text-white`}
                  title={status.title}
                >
                  {status.text}
                </span>
                <Link
                  to={campaignUrl}
                  className="badge bg-light text-muted border text-decoration-none"
                  title="Abrir campanha pela key."
                >
                  #{detail.raffle.key}
                </Link>
                <span className="badge bg-light text-muted border">
                  #{detail.raffle.campaign}
                </span>
              </div>
              <h1 className="h4 fw-bold mb-1">{detail.raffle.name}</h1>
              <div className="text-muted">
                @{detail.owner.atSign} · {detail.owner.name}
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
            <div className="border rounded px-3 py-2 bg-light">
              <small className="text-muted d-block">Ticket vencedor</small>
              <span className="fw-bold">
                <FaTicket className="me-1 text-primary" />
                {detail.winnerTicket
                  ? `${detail.winnerTicket.ticket} | Ordem #${masks.formatMilhar(
                      detail.winnerTicket.order,
                    )}`
                  : "Não informado"}
              </span>
            </div>
            <div className="border rounded px-3 py-2 bg-light">
              <small className="text-muted d-block">Finalizada em</small>
              <span className="fw-bold">
                <FaCalendarDays className="me-1 text-primary" />
                {detail.raffle.finishedAt
                  ? dayjs(detail.raffle.finishedAt).format(
                      "DD/MM/YYYY [às] HH:mm",
                    )
                  : "Não informado"}
              </span>
            </div>
          </div>
        </div>

        <div className="border-top mt-3 pt-3">
          <Link to="/my-rewards" className="btn btn-sm btn-outline-secondary">
            <FaArrowLeft className="me-2" />
            Voltar para meus prêmios
          </Link>
        </div>
      </div>
    </div>
  );
}
